import React, { useEffect, useRef, useState } from 'react';
import { useAuth, stopImpersonation } from '../auth.jsx';
import { useI18n } from '../i18n/index.jsx';

// Shown on every page while a super admin is logged in as a member.
export default function ImpersonationBanner() {
  const { user } = useAuth();
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const on = !!user?.impersonation;
  // The sticky header sits just below the banner, whatever its height.
  useEffect(() => {
    const el = ref.current;
    if (!on || !el) return undefined;
    const set = () => document.documentElement.style.setProperty('--imp-h', `${el.offsetHeight}px`);
    set();
    const ro = 'ResizeObserver' in window ? new ResizeObserver(set) : null;
    ro?.observe(el);
    return () => { ro?.disconnect(); document.documentElement.style.removeProperty('--imp-h'); };
  }, [on]);
  if (!on) return null;
  const who = [user.name, user.companyName].filter(Boolean).join(' – ');
  // A company owner in a member's account ("Ouvrir son compte"): their own wording, 30 minutes.
  const owner = user.impersonation.kind === 'owner';
  return (
    <div ref={ref} className={`imp-banner${owner ? ' is-owner' : ''}`} role="alert">
      <span className="imp-banner-dot" aria-hidden="true" />
      <span>{owner ? <>{t('impersonation.ownerAs', { who: user.name })} <span className="imp-banner-note">{t('impersonation.ownerNote', { n: user.impersonation.minutes || 30 })}</span></> : <><strong>{t('impersonation.mode')}</strong> {t('impersonation.as', { who })}</>}</span>
      <button type="button" className="imp-banner-back" disabled={busy} onClick={() => { setBusy(true); stopImpersonation('returned'); }}>
        {busy ? t('common.loading') : owner ? t('impersonation.ownerBack') : t('impersonation.back')}
      </button>
    </div>
  );
}
